const {
  default: Dashboard,
} = require("../components/admin/dashboard/Dashboard");
const { AllPermmission, } = require("../features/admin/common/Slice");
const { IMG_URL } = require("./common");

exports.APIS = {
  Auth: "/common/auth/admin-login",
  ChangePass: "/common/auth/change-password",
  UpdateProfile: "/common/auth/update-profile-photo",

  Dashboard: "/admin/dashboard",
  Easebuzz: "/easebuzz/initiate",

  node: IMG_URL,
  WhatsApp: {
    Generate: "/admin/connect-whatsapp/generate-qr",
    CRED: "/admin/connect-whatsapp/common/get-cred",
    updateWebhook: "/common/auth/update-webhok",
    ResetWhatsApp: "/admin/connect-whatsapp/common/reset-instance",
    LogOutWhatsApp: "/admin/connect-whatsapp/common/logout",
    GenerateNewApi: "/admin/connect-whatsapp/common/generate-api-key",
    DeleteWhatsApp: "/admin/connect-whatsapp/common/delete-instance",
    sendMessage: "/admin/connect-whatsapp/send-message",
    ReceiveMessage: "/admin/connect-whatsapp/common/receive-message",
    sendMessageReport: "/common/reports/send-message",
    ReceivedMessageReport: "/common/reports/received-message",
    RaiseTicket: "/common/support-ticket",
    GetAllGroups: "/admin/connect-whatsapp/group",
    GetMessages: "/admin/connect-whatsapp/group/get-message",
    CreateGroup: "/admin/connect-whatsapp/group/create-group",
    SendGroupMessage: "/admin/connect-whatsapp/group/send-message",
  }
  ,
  Masters: {
    Country: "/admin/masters/country",
    State: "/admin/masters/state",
    City: "/admin/masters/city",
    Pincode: "/admin/masters/pincode",
    Area: "/admin/masters/area",
    Orientation: "/admin/masters/orientation",
    PrintingLocations: "/admin/masters/printing-locations",
    Materials: "/admin/masters/materials",
    Laminations: "/admin/masters/laminations",
    Shapes: "/admin/masters/shapes",
    Partners: "/admin/masters/partners",
    WhyChooseUs: "/admin/masters/whychooseus",
    Industry: "/admin/masters/industry",
    Department: "/admin/masters/department",
    CompanySize: "/admin/masters/companysize",
    Faq: "/admin/masters/faqs",
    SubFaq: "/admin/masters/subfaq",
    Qty: "/admin/masters/qty",
    Envelopes: "/admin/masters/envelopes",
    SocialMedia: "/admin/masters/socialmedia",
    Coupons: "/admin/masters/coupons",
    Privacy_and_Policy: "/admin/masters/privacyandpolicy",
    Return_Policy: "/admin/masters/returnpolicy",
    Terms_and_Conditions: "/admin/masters/termsandconditions",
    Career: "/admin/masters/careers",
    Blog_Category: "/admin/masters/blog_categories",
    Blog: "/admin/masters/blogs",
    Size: "/admin/masters/sizes",
    Help: "/admin/masters/help",
    propertyType: "/admin/masters/property-type",
    roomType: "/admin/masters/room-type",
    Subscription: "/admin/subscription",
    Benefit: "/admin/benefits",
    Template: "/admin/masters/template",
    AutoReply: "/admin/masters/auto-reply",
    WelcomeMsg: "/admin/masters/welcome-message",
    ApiEndpoint: "/admin/masters/documentation/api-endpoint",
    ApiError: "/admin/masters/documentation/api-errors",

  },

  // common
  Commons: {
    AllCountry: "/common/masters/all-country",
    AllState: "/common/masters/all-state",
    AllCity: "/common/masters/all-city",
    AllPincode: "/common/masters/all-pincode",
    AllArea: "/common/masters/all-area",
    AllCategory: "/common/masters/all-category",
    AllSubCategory: "/common/masters/all-subcategory",
    AllChildCategory: "/common/masters/all-childcategory",
    AllPartners: "/common/masters/all-partners",
    AllWhyChooseUs: "/common/masters/all-whychooseus",
    AllIndustry: "/common/masters/all-industry",
    AllDepartment: "/common/masters/all-department",
    AllCompanySize: "/common/masters/all-companysize",
    AllNeeds: "/common/masters/all-needs",
    AllFaq: "/common/masters/all-faqs",
    AllSubFaq: "/common/masters/all-subfaq",

    AllMeterial: "/common/masters/all-material",
    AllLamination: "/common/masters/all-lamination",
    AllEnvelope: "/common/masters/all-envelope",
    AllPrintLocation: "/common/masters/all-print-location",
    AllQuantity: "/common/masters/all-quantity",
    AllOrientation: "/common/masters/all-Orientation",
    AllShapes: "/common/masters/all-shapes",

    AllSocialMedia: "/common/masters/all-socialmedia",
    AllBlog: "/common/masters/all-blogs",
    AllBlog_Category: "/common/masters/all-blogcategory",
    AllSize: "/common/masters/all-size",
    AllDownloadType: "/common/masters/all-download-type",
    AllOrderStatus: "/common/masters/all-order-status",
    AllPermmission: "/common/masters/all-permission",

    AllRoles: "/common/masters/all-roles",

    AllTeam: "/common/masters/all-team",
    AllProduct: "/common/masters/all-product",

    AllPropertyType: "/common/masters/all-property-type",
    AllPropertyStatus: "/common/masters/all-property-status",
    AllProperty: "/common/masters/all-property",
    AllRoom: "/common/masters/all-rooms",

    BuySubscription: "/common/buy-subscription",
    AllSubscriptionHistory: "/common/masters/all-subscription-history",
    paymentHistory: "/common/payment-history",
    AllBenefits: "/admin/benefits",
    AllMessageCombinations: "/common/masters/all-message-combination",
    AllTemplates: "/common/masters/all-templates"

  },

  //product Manage
  ProductManage: {
    Category: "/admin/productmanage/category",
    SubCategory: "/admin/productmanage/subcategory",
    ChildCategory: "/admin/productmanage/childcategory",
    Needs: "/admin/productmanage/needs",
    Product: "/admin/productmanage/product",
    OfferProduct: "/admin/productmanage/offered-product",
  },

  OrderManage: {
    Order: "/admin/order-management/order",
    OrderStatus: "/admin/order-management/order-status",
    PaymentProof: "/admin/order-management/accountant-payment-proof",
    PrintingCount: "/admin/order-management/printing-count",
    QCComment: "/admin/order-management/qc-comment",
    AssignDesigner: "/admin/order-management/assign-designer",

    DesignerNote: "/admin/order-management/designer-notes",
  },

  AboutUs: {
    Welcome: "/admin/aboutus/welcomes",
    What_We_Are: "/admin/aboutus/what_we_ares",
    What_Media_Do: "/admin/aboutus/what_media_dos",
  },

  Customers: {
    Contact_Us: "/admin/contact-us",
    User: "/admin/customer",
  },

  ReviewRating: {
    ReviewRating: "/admin/review-rating",

  },

  UserManagement: {
    Roles: "/admin/owner-management/role",
    Owner: "/admin/owner-management/users",
  },

  PropertyManage: {
    Property: "/admin/property-management",
    PropertyStatus: "/admin/property-management/property-status",
    room: "/admin/property-management/room",
    tenant: "/admin/tenant-management"
  }
};
